module.exports = __webpack_public_path__ + "static/img/logo13.e68195e3.png";